import { Col, Form, InputNumber, Row } from "antd";

import { SearchOutlined } from "@ant-design/icons";

import { Button } from "antd";
import React, { useState, useMemo } from "react";

import FormLabel from "../../../../components/label/FormLabel";
import { useEc2ZustandStore } from "../../../../zustand/store/useEc2ZustandStore";
import { useSearchInstances } from "./../../../../components/hooks/useSearchInstance";
import InstanceTable from "./InstanceTable";
function Ec2FormTable({ instanceCategory, selectedInfraClient, setChecked }) {
  // const [resourceType, setResourceType] = useState("cpu");
  const { ec2ZustandEditData, setEc2ZustandEditData } = useEc2ZustandStore();
  const [searchParams, setSearchParams] = useState({
    cpuValue: 0,
    gpuValue: 0,
    memValue: 0,
    resourceTypeInput: "cpu",
    apiRegion: instanceCategory ? "Singapore" : selectedInfraClient?.region,
  });
  
  // Memoize infraType to prevent unnecessary query key changes
  const infraType = useMemo(() => {
    if (ec2ZustandEditData?.infraType) {
      return ec2ZustandEditData.infraType.charAt(0).toUpperCase() +
        ec2ZustandEditData.infraType.slice(1);
    }
    return instanceCategory ? "Server" : "Client";
  }, [ec2ZustandEditData?.infraType, instanceCategory]);
  
  // Call the custom hook with the form values
  const {
    data: filteredInstances,
    error,
    isLoading,
    isFetching,
  } = useSearchInstances(
    searchParams.cpuValue,
    searchParams.memValue,
    searchParams.apiRegion,
    searchParams.resourceTypeInput,
    searchParams.gpuValue,
    infraType
  );

  const onFinish = (values) => {
    // console.log(values, "<===============");
    const { cpuValue, memValue, gpuValue } = values;
    if (ec2ZustandEditData?.region) {
      setSearchParams({
        cpuValue: cpuValue || 0,
        memValue,
        resourceTypeInput: gpuValue ? "gpu" : "cpu",
        apiRegion: ec2ZustandEditData?.region,
        gpuValue: gpuValue || 0,
      });
    } else {
      setSearchParams({
        cpuValue: cpuValue || 0,
        memValue,
        resourceTypeInput: gpuValue ? "gpu" : "cpu",
        apiRegion: instanceCategory ? "Singapore" : selectedInfraClient?.region,
        gpuValue: gpuValue || 0,
      });
    }
    // Removed manual refetch() - React Query automatically refetches when query key changes
  };
  //
  // const handleResourceTypeChange = (value) => {
  //   setResourceType(value);
  // };
  return (
    <>
      {/* {JSON.stringify(ec2ZustandEditData?.infraType)} */}
      {/* {infraType}=== */}
      <Form onFinish={onFinish} requiredMark={false}>
        <Row gutter={16}>
          {/* <Col lg={4}>
            <Form.Item
              label={<FormLabel>Type</FormLabel>}
              name="resourceTypeInput"
              rules={[{ required: true, message: "Fill resource type" }]}
            >
              <Select
                value={resourceType}
                className="w-[100%]"
                onChange={handleResourceTypeChange}
              >
                <Option value="cpu">CPU</Option>
                <Option value="gpu">GPU</Option>
              </Select>
            </Form.Item>
          </Col> */}

          <>
            {/* <Col lg={4}>
              <Form.Item
                className="w-[100%]"
                label={<FormLabel>CPU</FormLabel>}
                name="cpuValue"
                initialValue={1}
                rules={[
                  { required: true, message: "Please select a CPU value" },
                ]}
              >
                <Slider min={1} max={100} />
              </Form.Item>
            </Col> */}
            <Col lg={6}>
              <Form.Item
                className="w-[100%]"
                label={<FormLabel requiredMark={false}>GPU</FormLabel>}
                name="gpuValue"
              >
                <InputNumber className="w-[100%]" min={0} max={100} />
              </Form.Item>
            </Col>
            <Col lg={6}>
              <Form.Item
                className="w-[100%]"
                label={<FormLabel>CPU</FormLabel>}
                name="cpuValue"
                rules={[
                  { required: true, message: "Please enter a CPU value" },
                ]}
              >
                <InputNumber className="w-[100%]" min={1} max={300} />
              </Form.Item>
            </Col>
          </>

          {/* <Col lg={6}>
            <Form.Item
              className="w-[100%]"
              label={<FormLabel>Memory in GB</FormLabel>}
              name="memValue"
              initialValue={1}
              rules={[
                { required: true, message: "Please select a memory value" },
              ]}
            >
              <Slider min={1} max={100} />
            </Form.Item>
          </Col> */}
          <Col lg={8}>
            <Form.Item
              className="w-[100%]"
              label={<FormLabel>Memory in GB</FormLabel>}
              name="memValue"
              rules={[
                { required: true, message: "Please enter a memory value" },
              ]}
            >
              <InputNumber className="w-[100%]" min={1} max={300} />
            </Form.Item>
          </Col>
          <Col lg={4}>
            <Form.Item>
              <Button
                className="w-[100%]"
                type="primary"
                htmlType="submit"
                loading={isFetching}
                icon={<SearchOutlined />}
              >
                Search
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <InstanceTable
        setChecked={setChecked}
        instanceCategory={instanceCategory}
        data={filteredInstances}
        selectedInfraClient={selectedInfraClient}
        loading={isFetching}
      />
    </>
  );
}

export default Ec2FormTable;
